import React from "react"
import moment from "moment"
import { baseUrlImg } from "../../config/api"

const BetFlagDirectTicket = ({ arr }) => {
  const receiptData = arr.receipt ? JSON.parse(arr.receipt) : {}

  return (
    <div className="json_spedizionepro">
      <div
        className="d-flex justify-content-center mb-4"
        style={{ border: "unset" }}
      >
        <img src={`${baseUrlImg}/${arr.logo}`} alt="service logo" height={50} />
      </div>

      <div style={{ paddingTop: 10 }}>
        Data/Ora:
        <span>{moment(receiptData.dataAcquisto).format("DD/MM/YYYY HH:mm:ss")}</span>
      </div>
      <div style={{ paddingTop: 10 }}>
        Importo: <span>{(parseFloat(receiptData.importo) / 100).toFixed(2)} €</span>
      </div>
      <div style={{ paddingTop: 10 }}>
        Codice Voucher: <span>{receiptData.codiceVoucher}</span>
      </div>
      <div style={{ paddingTop: 10 }}>
        ID Transazione: <span>{receiptData.idTransazione}</span>
      </div>
    </div>
  )
}

export default BetFlagDirectTicket
